import React from 'react';
import '../../assets/css/Legal.css';

const RefundPolicy = () => {
  return (
    <div className="legal-page">
      <section className="hero-section">
        <div className="container">
          <div className="hero-content">
            <h1>Refund Policy</h1>
            <p className="hero-subtitle">
              Understanding Samyama refund and cancellation procedures
            </p>
          </div>
        </div>
      </section>

      <section className="section">
        <div className="container">
          <div className="legal-content">
            <div className="legal-meta">
            <p><strong>Operated by:</strong> VaidhyaMegha Private Limited</p>
              <p><strong>Effective Date:</strong> 01-June-2025</p>
              <p><strong>Next Update:</strong> 01-Dec-2025</p>
            </div>
            
            <div className="legal-section">
              <h2>1. General Policy </h2>
              <p>
              At Samyama, we strive to deliver high-quality, AI-driven services, insights, and digital tools that are tailored to each user’s interaction in real time.
              </p>
              <p>
              Due to the intangible, instantaneous, and customized nature of our services, all sales are considered final and non-refundable unless:
              </p>
              <ul>
                <li>
                A different policy is explicitly stated in writing at the point of sale; or
                </li>
                <li>
                A refund is required by applicable law or regulatory compliance.
                </li>
              </ul>
            </div>

            <div className="legal-section">
              <h2>2. Non-Refundable Services </h2>
              <p>
              To ensure clarity and prevent misuse, the following services and digital products are strictly non-refundable under all circumstances, once delivered or activated:
              </p>
              <p> AI consultations and diagnostic outputs </p>
              <p> Includes healthcare, legal, wellness, or educational responses generated through AI models. </p>
              <p> Subscription-based services or access plans </p>
              <p>Any plan that has been partially or fully used, including auto-renewed periods, is not eligible for a refund.</p>
              <p> One-time digital reports, insights, or downloadable content </p>
              <p>This includes any personalized recommendations, PDF downloads, CSV exports, or system-generated data files.</p>
              <p> API usage credits or tokens </p>
              <p>Once credits are consumed, or services accessed through API integrations, no reversals or refunds are allowed.</p>
              <p> Platform training sessions or onboarding packages </p>
              <p>This includes remote onboarding, workshops, or implementation support sessions—once scheduled or delivered.</p>
              <p>Please review your purchase carefully before completing payment, especially for services that are instantly accessible or one-time in nature.</p>
            </div>

            <div className="legal-section">
              <h2>3. Exceptions to Refund Policy </h2>
              <p>
              While most purchases are final, we may offer a partial or full refund under the following exceptional cases, subject to internal review and verification:

              </p>
              <p>
              Duplicate payments
              </p>
              <p>
              Accidental double billing or repeated charges for the same service caused by a technical or payment gateway error.
              </p>
              <p>
              Service failure due to platform outage
              </p>
              <p>
              Verified and continuous unavailability of a core service caused by Samyama's internal system or infrastructure issues, lasting longer than 48 consecutive hours.
              </p>
              <p>
              Unintentional charge to an incorrect account
              </p>
              <p>
              Payments made to the wrong user profile or corporate account must be reported within 7 calendar days of the transaction.
              </p>
              <p>
              Auto-renewal cancellation before use
              </p>
              <p>
              If a recurring subscription was charged automatically, but the service was not used during that billing cycle, and cancellation is requested promptly.
              </p>
              <p>
              How to Request a Refund
              </p>
              <p>
              To request a refund under one of the above conditions:
              <ul>
                <li>
                Send a written request to support@samyama.ai
                </li>
                <li>
                The request must be made within 7 calendar days of the original transaction date
                </li>
                <li>
                Include supporting documentation such as:
                <ul>
                  <li>
                  Payment confirmation receipts
                  </li>
                  <li>
                  Screenshots or error logs
                  </li>
                  <li>
                  Relevant email communications
                  </li>
                </ul>
                </li>
                
              </ul>
              </p>
              <p>
              Refund approvals are at the sole discretion of VaidhyaMegha Private Limited after case-by-case assessment.
              </p>
              
            </div>

            <div className="legal-section">
              <h2>4. Refund Processing Timeline</h2>
              <p>
              If your refund request is approved after review, the refund will be processed in accordance with the following terms:
              </p>
              <p>
              Processing Timeframe:
              </p>
              <p>
              Refunds will be issued within 7–10 business days from the date of approval.
              </p>
              <p>
              Payment Method:
              </p>
              <p>
              Refunds will be credited only to the original method of payment used at the time of purchase. Alternative accounts or third-party transfers are not supported.
              </p>
              <p>
              Bank/Provider Delays:
              </p>
              <p>
              Actual posting times may vary based on your bank, payment processor, or card issuer. Samyama is not liable for additional delays once the refund has been processed on our end.
              </p>
              <p>
              If you do not receive your refund within 14 business days of confirmation, please contact contact@samyama.ai with your transaction ID for follow-up.
              </p>
            </div>

            <div className="legal-section">
              <h2>5. Disputes and Chargebacks</h2>
              <p>
              If you initiate a chargeback or payment dispute through your bank or card issuer without first contacting Samyama Support, the following actions may be taken:
              </p>
              <p> Account Suspension</p>
              <p> Your account may be temporarily suspended or access-limited while the dispute is under investigation. </p>
              <p> Chargeback Challenge</p>
              <p> We reserve the right to contest the dispute using detailed payment logs, usage history, and service records to demonstrate service fulfillment. </p>
              <p> Loss of Access to Paid Services</p>
              <p> Repeated chargebacks or unresolved payment disputes may result in permanent restriction from future purchases or premium services on the platform. </p>
              <p> We strongly encourage users to contact us first at support@samyama.ai so we can investigate and resolve issues amicably and promptly. </p>
              </div>
            
              <div className="legal-section">
              <h2>6. Contact for Refunds </h2>
              <p>
              If you believe you're eligible for a refund under this policy, please contact us at:
              </p>
              <p>
              VaidhyaMegha Private Limited
              </p>
              <p>
              Email: enquiry@samyama.ai
              </p>
              <p>
              Phone: +91 9618986039
              </p>
              <p>Our support team is committed to responding within 3–5 business days of your inquiry.</p>
              </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default RefundPolicy;
